import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "nr-table-header" }
const _hoisted_2 = { class: "nr-table-header__count" }
const _hoisted_3 = {
  key: 0,
  ref: "dropdown",
  class: "dropdown-filter"
}
const _hoisted_4 = {
  id: "column-picker",
  class: "dropdown-content",
  ref: "dropdown-content"
}
const _hoisted_5 = { ref: "dropdownColumnPicker" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrIconButton = _resolveComponent("NrIconButton")!
  const _component_NrTooltip = _resolveComponent("NrTooltip")!
  const _component_NrFormInput = _resolveComponent("NrFormInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_NrIconButton, {
        size: "small",
        variant: "minimal-neutral",
        "aria-label": "Toggle sidebar",
        icon: { name: 'filter', type: $data.filterToggled ? 'solid' : 'regular' },
        onClick: $options.handleSidebarToggle
      }, null, 8, ["icon", "onClick"]),
      _createElementVNode("span", _hoisted_2, [
        _renderSlot(_ctx.$slots, "count", {}, () => [
          _createTextVNode(_toDisplayString($props.resultCount) + " / " + _toDisplayString($props.totalCount), 1)
        ])
      ]),
      _createTextVNode(" " + _toDisplayString(' ') + " "),
      ($props.tableHeaderTitleTooltip)
        ? (_openBlock(), _createBlock(_component_NrTooltip, { key: 0 }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString($props.tableHeaderTitleTooltip), 1)
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString($props.tableHeaderTitle), 1)
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString($props.tableHeaderTitle), 1)
          ], 64))
    ]),
    ($props.enableColumnFilter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_NrIconButton, {
            variant: "minimal-neutral",
            icon: { name: 'columns', type: 'regular' },
            title: "Change table column visibility",
            "aria-label": "Change table column visibility",
            onClick: $options.toggleColumnFilter,
            "aria-expanded": $props.enableColumnFilter,
            disabled: !$props.resultCount
          }, null, 8, ["onClick", "aria-expanded", "disabled"]),
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            _createElementVNode("form", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.columns, (column, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "field",
                  key: `column-${index}`
                }, [
                  _createVNode(_component_NrFormInput, {
                    type: "checkbox",
                    label: column.label,
                    modelValue: !column.hidden,
                    "onUpdate:modelValue": ($event: any) => ($options.updateColumnValue(column, $event))
                  }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
                ]))
              }), 128))
            ], 512)
          ], 512), [
            [_vShow, $data.columnFilterToggled]
          ])
        ], 512))
      : _createCommentVNode("", true)
  ]))
}